import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';

import {environment} from 'environment';
import {UserInfo} from './../models/user-info';
import {IRegistrationRepository} from './registration.repository.interface';

@Injectable()
export class RegistrationRepository implements IRegistrationRepository {

  constructor(private http: HttpClient) { }

  public register(userInfo: UserInfo): Observable<string> {
    const headers: HttpHeaders = new HttpHeaders();
    headers.append('Content-Type', 'application/json');

    return this.http.post<string>(`${environment.registration}/register`, userInfo, {headers: headers, withCredentials: true})
      .pipe(
//        map((response: Response) => response.json()),
        catchError(this.handleError)
      );
  }

  public isValid(voucherCode: string): Observable<boolean> {

    return this.http.get<boolean>(`${environment.voucher}/valid/${voucherCode}`, {withCredentials: true})
      .pipe(
//        map((response: Response) => response.json()),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }
}
